<unity-page-container contentHeader="Business Partner Management" [isLoading]="false">
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>
  <ng-container notifications />

  <ng-container actions>
    <unity-action-shared [action]="createBusinessPartnerAction" />
  </ng-container>

  <unity-grid-agency-shared />
</unity-page-container>
